const style1 = {
    backgroundColor: '#4F81BD',
    color: '#fff',
    minWidth: '150px',
};
const style2 = {
    backgroundColor: '#00B050',
    color: '#fff',
};

export const HeaderStandard = [
    [
        { text: 'S.No.', style: style1 },
        { text: 'Check Points', style: style1 },
        { text: 'Specification', style: style1 },
        { text: 'Checking/Maitenance Method', style: style1 },
        { text: 'Status (OK/NG)', style: style1 },
        { text: 'Observations', style: { ...style1, minWidth: '300px' } },
        { text: 'Action Taken', style: style1 },
        { text: 'Remarks', style: style1 },
    ],
];

export const headerConstant = {
    tableCompHeadTitle: 'PREDICTIVE Maintenance CHECKSHEET ',
    addButtonLable: '',
    datePickerLabel: 'Search By Year',
    modalTile: 'UPDATE STATUS',
};

export const apiConstant = {
    getById: 'predictiveMaintenancePlanStatusCheckListRoute',
    post: 'predictiveMaintenancePlanStatusCheckListRoute',
    update: 'predictiveMaintenancePlanStatusCheckListRoute',
    delete: 'predictiveMaintenancePlanStatusCheckListRoute',
    // below this master checklist api
    masterCheckListAutoComplete:
        'predictiveMaintenancePlanMasterChecklistRoute/masterCheckListAutoComplete',
    getMasterCheckListById: 'predictiveMaintenancePlanMasterChecklistRoute',
};

export const navigationConstant = {};
